import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";

const TermsOfSale: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Terms of Sale",
      path: "/terms-of-sale",
    },
  ];

  return (
    <div className="flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Terms of Sale Content */}
        <div className="w-full pt-[15px] pb-[86px] bg-white">
          <div className="px-5 max-w-[1710px] mx-auto mb-10">
            <h1 className="text-3xl md:text-[30px] font-semibold text-[#202020] mb-6 mt-[30px]">
              Terms of Sale
            </h1>

            <div className="space-y-[30px] text-[#101010] font-normal text-[16px] leading-[25px]">
              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  Overview
                </h2>
                <p>
                  Unless otherwise expressly agreed in a writing signed by an
                  officer of PPE.us, all sales are subject to the following
                  terms and conditions ("Standard Terms"). These Standard Terms
                  are incorporated by this reference into every offer to sell,
                  Quote, Order, purchase, Order Acknowledgement and invoice
                  issued by Seller.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  1. Definitions
                </h2>
                <p>
                  (a) A "<strong className="font-semibold">Buyer</strong>" is
                  defined as the person or entity named in any Online Order, or
                  in a Quote or Order Acknowledgement, or named in any purchase
                  order or other form prepared by such person or entity,
                  relating to the purchase of the Products.
                </p>
                <p>
                  (b) An "
                  <strong className="font-semibold">Online Order</strong>" is an
                  Order submitted at the Website (as defined below) by the Buyer
                  which has been accepted by Seller in writing.
                </p>
                <p>
                  (c) An "<strong className="font-semibold">Order</strong>" is
                  any offer to purchase the Products made by a Buyer that is
                  accepted in writing by Seller and subject solely to the
                  provisions of these Standard Terms and no other terms of the
                  Buyer (unless otherwise agreed by Seller in writing).
                </p>
                <p>
                  (d) An "
                  <strong className="font-semibold">
                    Order Acknowledgement
                  </strong>
                  " is a final written acknowledgement issued by the Seller with
                  respect to the terms of an Order accepted by the Seller.
                </p>
                <p>
                  (e) "<strong className="font-semibold">Products</strong>" are
                  all of the goods and/or services to be sold by Seller that are
                  referred to in an Order.
                </p>
                <p>
                  (f) A "<strong className="font-semibold">Quote</strong>" is a
                  written final quotation for the sale of Products issued by the
                  Seller.
                </p>
                <p>
                  (g) The "<strong className="font-semibold">Website</strong>"
                  is any website operated by Seller where Products may be
                  purchased.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  2. Acceptance Of Order & Standard Terms
                </h2>
                <p>
                  Buyer agrees to all of these Standard Terms, and an Order is
                  deemed final and legally binding between Buyer and Seller,
                  once any of the following occurs: (a) Submission of an Online
                  Order by Buyer that has been accepted by Seller in writing;
                  (b) Buyer's acceptance of Seller's Quote for the Products; (c)
                  issuance of an Order Acknowledgement by Seller; (d) issuance
                  of a purchase order by the Buyer for the Products; (e) payment
                  by Buyer for all or part of the Products or the payment of any
                  deposit; or (f) acceptance of delivery of all or any part of
                  the Products. Seller objects to and will not agree to any
                  terms that are additional to or different from these Standard
                  Terms. Terms that are printed on or contained in a purchase
                  order or other form prepared by Buyer which are in addition
                  to, in conflict with, or inconsistent with, these Standard
                  Terms shall be deemed material alterations within the meaning
                  of the Uniform Commercial Code and are objected to and
                  rejected, and shall be considered to be inapplicable, and
                  shall have no force or effect. All orders are subject to the
                  written approval of Seller. Seller may refuse or limit any
                  Order for any reason.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  3. Entire Contract
                </h2>
                <p>
                  The Order, including any final Quote of Seller and/or Order
                  Acknowledgement of Seller associated with the Order, and any
                  non-disclosure agreement entered into between Seller and Buyer
                  relating to such Order ("<strong className="font-semibold">NDA</strong>"), constitutes
                  the final, complete and exclusive statement of all the terms
                  of agreement between Seller and Buyer, and no prior oral or
                  written agreement, or prior purchase order or form shall be a
                  part of or a modification of the Order. No change,
                  modification or waiver of any of the terms of agreement
                  between Seller and Buyer after acceptance of the Order by
                  Seller in writing shall be binding upon Seller unless agreed
                  to in a writing signed by an officer of Seller.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  4. Price
                </h2>
                <p>
                  The price for a Product shall be the price stated at the
                  Website or in Seller's final Quote for the Product or in
                  Seller's Order Acknowledgement; provided, however, that prices
                  are subject to change without notice until such time as Seller
                  finalizes and accepts an Order in writing. Unless otherwise
                  stated in a Quote, prices for the Product which are stated in
                  a Quote are valid for thirty (30) days from the Quote date.
                  Buyer shall pay any extra costs incurred by Seller as a result
                  of any changes or modifications to Product specifications
                  requested by Buyer. Prices are exclusive of all taxes, fees,
                  duties, levies or other governmental assessments ("
                  <strong className="font-semibold">Taxes</strong>") and, unless otherwise stated at the
                  Website or in a Quote, also exclude costs including but not
                  limited to shipping and handling charges, freight, insurance
                  and other costs which may be separately billed to Buyer. All
                  Taxes related to Product shall be paid by Buyer, or in lieu
                  thereof, Buyer shall provide Seller with a tax exemption
                  certificate acceptable to the relevant taxing authorities.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  5. Payment Terms
                </h2>
                <p>
                  For Online Orders payment terms shall be as set forth at the
                  Website. For all other Orders, payment shall be due as set
                  forth in Seller's Quote, Order Acknowledgement or invoice. If
                  no such payment date is specified, then payment will be due
                  thirty (30) days after the date of Seller's invoice. All
                  payments must be made in U.S. Dollars. Seller reserves the
                  right to charge at any time a monthly service charge of one
                  and one-half percent (1.5%) or the highest rate allowed by
                  law, whichever is lower, on outstanding amounts that are not
                  paid when due, effective as of the first day after the due
                  date. If Buyer fails to fulfill the terms of payment or does
                  not meet Seller's continuing credit requirements, Seller will
                  have the option to do one or more of the following: (a)
                  decline to accept an Orders or fulfill pending Orders; (b)
                  require all pending and future Orders to be on a prepaid
                  basis; (c) delay any shipment until payment is received by
                  Seller or further assurances asked for by Seller are received;
                  (d) declare all outstanding sums immediately due and payable;
                  or (e) require payment for all Products delivered hereunder to
                  be made by irrevocable letter of credit in a form approved by
                  Seller. All Orders are subject to current credit approval.
                  From time to time, Seller may review Buyer's creditworthiness.
                  Buyer agrees to provide Seller with all credit information
                  reasonably requested, and Buyer represents and warrants to
                  Seller that each time Buyer places an Order, all information
                  Buyer has provided is true and correct. All amounts due Seller
                  herein shall not be subject to deduction or offset by Buyer by
                  reason of any counterclaim arising out of this or any other
                  transaction between Seller and Buyer.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  6. Delivery Time; Title; Risk Of Loss
                </h2>
                <p>
                  Shipping, delivery and performance dates are estimates only,
                  calculated from the date of receipt of Buyer's Order and any
                  drawings, specifications, designs, samples or other
                  information reasonably requested by Seller to manufacture or
                  source the Products, and time is not of the essence. Seller
                  shall not incur any liability, nor shall any Order be
                  canceled, because or as a result of any delays in meeting
                  shipping or delivery dates or schedules. Seller reserves the
                  right to recalculate any projected shipping, delivery or
                  performance dates upon finalization of Buyer's Order or at
                  anytime thereafter. Seller may ship all the Products at one
                  time or in portions from time to time. Unless otherwise agreed
                  by Seller in writing, all shipments to points in the U.S. will
                  be delivered by Seller FOB Seller's facility or other location
                  designated by Seller, and all shipments to points outside the
                  U.S. will be delivered by Seller EXW Seller's facility (as
                  such term is defined in Incoterms 2010) or other location
                  designated by Seller; provided, however, that unless Buyer
                  advises Seller that it will arrange and take responsibility
                  for shipment of Products from Seller's facility or other
                  location designated by Seller, Seller will arrange for its
                  freight forwarder and/or carrier(s) to transport the Products
                  to Buyer's specified location at Buyer's cost. Title to and
                  risk of loss or damage for all Products will pass to Buyer
                  upon Seller's delivery of the Products to the carrier or as
                  otherwise provided above. In all cases of damage and/or loss
                  to Products in transit, Buyer will be responsible for making
                  claim(s) against the carrier; provided, however, that Seller
                  will provide reasonable assistance with damage and/or loss
                  claims. Loss of or damage to Products after Products are
                  delivered to the carrier will not relieve Buyer of any
                  obligations for payment or other obligations in the Order.
                  Unless otherwise agreed by Seller in writing, shipping,
                  freight, handling, insurance, and related costs are the sole
                  responsibility of Buyer.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  7. Inspection/Acceptance
                </h2>
                <p>
                  Buyer must inspect delivered Products and report claims for
                  damages, shortages or receipt of wrong products which are
                  discoverable on a visual inspection within 48 hours of
                  delivery (or within five [5] days if the damage or defect is
                  not discoverable on a visual inspection) or the Products will
                  be deemed irrevocably accepted and such claims will be deemed
                  waived. However, shipping damage claims must be made by Buyer
                  directly with the shipping company in accordance with such
                  company's policies, which generally require such claims to be
                  made prior to the time the carrier of the Products leaves the
                  delivery destination. Buyer will advise Seller of any such
                  claims. For any valid claim timely made that does not result
                  from the actions of a carrier, Seller, at its option, may
                  repair the Product, or replace the Product with an identical
                  or substantially similar product, or refund or credit the
                  purchase price to Buyer for the affected Product. THESE ARE
                  BUYER'S SOLE AND EXCLUSIVE REMEDIES WITH RESPECT TO SELLER FOR
                  DAMAGED OR MISSING PRODUCT. For defective product, the
                  warranty remedies described herein, if any, shall apply.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  8. Return & Refund Policy
                </h2>
                <p>
                  <strong className="font-semibold">
                    EXCEPT AS PROVIDED IN SECTION 9 BELOW, OR UNLESS OTHERWISE
                    AUTHORIZED BY SELLER IN WRITING, ALL SALES ARE FINAL AND NO
                    RETURNS OR REFUNDS ARE ALLOWED OTHER THAN AS PROVIDED
                    HEREIN.
                  </strong>{" "}
                  For damaged or missing Product, see Section 7 herein. For
                  defective Product, see Section 11 herein.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  9. Cancellation/Changes
                </h2>
                <p>
                  <strong className="font-semibold">
                    AFTER ACCEPTANCE OF AN ORDER BY SELLER, A SALE IS FINAL AND
                    CANNOT BE CANCELLED OR CHANGED BY BUYER WITHOUT SELLER'S
                    WRITTEN CONSENT; PROVIDED, HOWEVER, THAT FOR ANY PRODUCT
                    IMPORTED ON BEHALF OF BUYER, IN THE EVENT THE PRODUCT FAILS
                    TO SHIP WITHIN 30 DAYS AFTER THE QUOTED DELIVERY DATE, THEN
                    BUYER MAY, AT ITS OPTION, CANCEL ANY PORTION OF THE ORDER
                    PERTAINING TO SUCH PRODUCT PRIOR TO THE SHIPMENT OF THE
                    PRODUCT. ONCE THE IMPORTED PRODUCT IS IN TRANSIT, THE SALE
                    IS FINAL AND CANNOT BE CANCELLED OR CHANGED BY BUYER.
                  </strong>
                </p>
                <p className="mt-[18px]">
                  Any other changes to an Order requested by Buyer will require
                  the prior written approval of Seller, which approval may be
                  subject to price adjustments or changes to delivery dates as
                  determined on a case-by-case basis. Buyer assumes all
                  responsibility for errors in specifications and Buyer
                  Materials provided to Seller and/or for Products approved by
                  Buyer. Clerical errors in Orders are subject to correction by
                  Seller. Seller may, with or without notice, cancel all or any
                  part of an Order at any time (including after an Order has
                  been submitted or accepted) without liability to Buyer except
                  to refund to Buyer any amounts paid by Buyer for Product not
                  delivered by Seller.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  10. Force Majeure
                </h2>
                <p>
                  Seller shall not be labile for any delay or failure of
                  performance where such delay or failure arises from a cause
                  beyond Seller's reasonable control (a "
                  <strong className="font-semibold">Force Majeure Event</strong>"). In such event Seller
                  may, at its option and without obligation or liability to
                  Buyer (except to refund to Buyer any amounts paid by Buyer for
                  Product not delivered by Seller), cancel all or any part of an
                  Order, or may delay delivery of Products. Causes beyond
                  Seller's reasonable control shall include, but not be limited
                  to, fires, floods, severe weather, earthquakes, accidents,
                  riots, civil disorder, acts of war or terrorism, strikes or
                  other labor difficulties, disease, viruses, epidemics,
                  contamination, equipment failure, utilities interruption,
                  inability or delay in obtaining materials or products, carrier
                  delays, embargoes, or any law, order, regulation or other
                  action adopted or taken by any governmental authority, or any
                  other cause not reasonably within Seller's control, whether or
                  not specifically mentioned herein.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  11. Warranty
                </h2>
                <p>
                  SELLER MAKES NO WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT
                  TO ANY PRODUCTS NOT MANUFACTURED BY SELLER. Such Products
                  carry the original manufacturer's warranty (if any) and Buyer
                  must submit warranty claims regarding such Products to the
                  original manufacturer in accordance with such manufacturer's
                  warranty policies. With respect to Products that are
                  manufactured solely by Seller, Seller warrants to Buyer that
                  such Products will be free from defects in material and
                  workmanship under normal use for a warranty period of ninety
                  (90) days following shipment from Seller. Any disposable
                  Products manufactured by Seller are warranted for single use
                  only. The warranty does not cover and Seller will have no
                  warranty obligation whatsoever with respect to any damage to a
                  Product caused by or associated with: (a) usage not in
                  accordance with Product instructions or usage for a purpose
                  not indicated on the labeling; (b) abuse, misuse, neglect,
                  improper maintenance or storage, accident, vandalism, or the
                  negligence of any party other than Seller; (c) a Force Majeure
                  Event; (d) use of unauthorized third party consumables and
                  accessories with the Product; or (e) modifications or
                  alterations to a Product not authorized by Seller. Seller's
                  obligations under this limited warranty are contingent on
                  Buyer's full payment of the Product purchase price. SELLER
                  EXPRESSLY DISCLAIMS ALL OTHER WARRANTIES AND CONDITIONS,
                  EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, WITHOUT
                  LIMITATION, WARRANTIES OR CONDITIONS OF MERCHANTABILITY AND
                  FITNESS FOR A PARTICULAR PURPOSE, AS WELL AS WARRANTIES
                  ARISING FROM COURSE OF DEALING AND USAGE OF TRADE, AND SELLER
                  DOES NOT REPRESENT OR WARRANT THAT ANY PRODUCT WILL MEET
                  BUYER'S REQUIREMENTS. Notice of a defective Product under
                  Seller warranty must be given to Seller in writing within ten
                  (10) days following the discovery of such defect. Any oral or
                  written statement concerning the Products inconsistent with
                  the warranty set forth herein will be of no force or effect.
                  Seller's sole liability, and Buyer's exclusive remedy, for a
                  defect in a Product manufactured solely by Seller that is
                  covered under the warranty will be, at Seller's option, for
                  Seller to either replace or repair the defective Product(s),
                  or refund or credit the purchase price to Buyer.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  12. Limitation Of Liability
                </h2>
                <p>
                  UNDER NO CIRCUMSTANCES WILL EITHER PARTY HAVE ANY LIABILITY TO
                  THE OTHER PARTY FOR, AND EACH PARTY HEREBY EXPRESSLY WAIVES,
                  ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE
                  DAMAGES OF ANY DESCRIPTION, EVEN IF ADVISED OF THE POSSIBILITY
                  OF SUCH DAMAGES, WHETHER ARISING OUT OF WARRANTY OR CONTRACT,
                  NEGLIGENCE OR OTHER TORT, OR OTHERWISE, INCLUDING, WITHOUT
                  LIMITATION, FORESEEABLE BUSINESS LOSSES, LOSS OF PROFITS, AND
                  RELIANCE DAMAGES. BUYER AGREES THAT UNDER NO CIRCUMSTANCES
                  WILL SELLER'S LIABILITY RELATING TO ITS SALE OF PRODUCTS TO
                  BUYER FOR ANY CAUSE EXCEED THE PURCHASE PRICE PAID BY BUYER
                  FOR THE PARTICULAR PRODUCTS INVOLVED.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  13. Compliance With Laws
                </h2>
                <p>
                  Unless otherwise expressly stated in writing by Seller, no
                  claim or representation is made or intended (a) that any
                  Product has been cleared, approved, registered or otherwise
                  qualified by Seller with any federal, state, local,
                  provincial, foreign or any other governmental or
                  quasi-governmental agency or regulatory body (collectively, "
                  <strong className="font-semibold">Regulatory Agencies</strong>") or under any laws,
                  rules or regulations, including but not limited to those
                  governing healthcare and medical products (collectively, "
                  <strong className="font-semibold">Regulatory Laws</strong>"), (b) that any Product will
                  satisfy the requirements of any Regulatory Agencies or
                  Regulatory Laws, or (c) that any Product or its performance is
                  suitable, safe or effective, or has been validated for, any
                  specific use or application. Nothing herein or in any Order
                  shall require Seller to violate any applicable law.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  14. Resale & Export
                </h2>
                <p>
                  Unless otherwise agreed by Seller in writing, Buyer agrees
                  that it is purchasing the Products for its own use and not for
                  resale. Accordingly, unless otherwise agreed by Seller in
                  writing, Products purchased pursuant to an Order may not be
                  sold or transferred to any person or entity for purposes of
                  resale. Buyer acknowledges that the Products sold under an
                  Order, and the transaction contemplated by an Order, may be
                  subject to U.S. customs and export control laws and
                  regulations (including but not limited to restrictions on
                  persons, entities and countries who may receive the Products),
                  as well as customs and export laws and regulations of the
                  country in which the Products are received. Buyer acknowledges
                  and agrees that it is Buyer's sole responsibility to comply
                  with and abide by all such applicable laws and regulations and
                  that Buyer will not export or transfer Products for export in
                  violation of any such laws.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  15. Medical Devices
                </h2>
                <p>
                  If the Product requires medical device registration with the
                  U.S. Food and Drug Administration (is a "
                  <strong className="font-semibold">Medical Device</strong>"), then in addition to the
                  other terms and conditions herein: (a) Buyer must ensure that
                  the Medical Device users are fully qualified in the use and
                  operation of the Medical Device; (b) all clinical and medical
                  treatment, diagnostic and cost reporting and billing decisions
                  regarding the Medical Device are Buyer's sole responsibility;
                  and (c) Buyer represents and warrants that it is, and at all
                  times will be, in full compliance with all applicable
                  Regulatory Laws regulating healthcare, medical products and
                  Medical Devices.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  16. Buyer Representations & Warranties
                </h2>
                <p>
                  Buyer represents and warrants that (a) Buyer will comply with
                  all applicable national, state and local laws, orders, rules
                  and regulations (including but not limited to any applicable
                  Regulatory Laws, export control laws, the Foreign Corrupt
                  Practices Act, anti-corruption and anti-bribery laws, and
                  anti-kickback laws) with respect to the purchase, sale,
                  marketing, distribution and use of the Products; (b) any
                  Licensed Material (as defined herein) provided by Buyer to be
                  applied to the Products shall not infringe or violate any
                  patents, copyrights, trademarks, trade names, or other
                  intellectual property rights of any third party; (c) Buyer
                  will use all Products in accordance with the packaging
                  labeling and instructions of the manufacturer; (d) if the
                  Products are not already subject to Regulatory Laws, shall not
                  market, sell, distribute or use the Products in a manner which
                  would require approval of Regulatory Agencies; and (e) if the
                  Products are already subject to Regulatory Laws, shall not
                  market, sell, distribute or use the Products in a manner which
                  would require additional approvals by Regulatory Agencies.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  17. Indemnity
                </h2>
                <p>
                  Buyer shall defend, indemnify and hold the Seller, and its
                  officers, directors, employees and agents (hereafter
                  collectively, including the Seller, the "
                  <strong className="font-semibold">Seller-Affiliated Entities</strong>"), harmless from
                  and against any and all losses, damages, liabilities, claims,
                  demands, lawsuits and expenses, including court costs and
                  attorneys' fees (collectively, "<strong className="font-semibold">Claims</strong>"),
                  that such entities may incur arising out of or in any way
                  resulting from, whether directly or indirectly: (a) Buyer's
                  sale, marketing, distribution or use of the Products; (b) any
                  act or omission of Buyer, its affiliated companies, or the
                  officers, directors, employees, agents, representatives,
                  subcontractors or distributors of each; (c) any breach of an
                  Order or these Standard Terms, or the representations and
                  warranties of Buyer herein; (d) any storage or use of Products
                  that is not in accordance with the packaging labeling and
                  instructions of the manufacturer; (e) any specifications or
                  requirements furnished by Buyer for the Product; (f) any
                  negligent act, omission or intentional misconduct on the part
                  of Buyer, its affiliated companies, or the officers,
                  directors, employees, agents, representatives, subcontractors
                  or distributors of each; or (g) any cleaning, sterilization of
                  or modifications to the Product or any combination of the
                  Product with any other products, materials or chemicals. Upon
                  the commencement of any Claim to which this indemnification
                  applies, Seller shall promptly notify Buyer, and Buyer shall
                  assume and diligently conduct the entire defense thereof,
                  including any appeals, at its own sole cost and expense, and
                  shall pay and discharge any and all settlement amounts,
                  judgments or decrees which may be rendered; provided, however,
                  that Buyer shall not enter into any settlement or compromise
                  of a Claim without Seller's prior written consent, which
                  consent shall not be unreasonably withheld. Without releasing
                  any obligation, liability or undertaking of Buyer, Seller,
                  insofar as its interests are affected, may at its sole
                  election supersede Buyer in any such defense and thereafter
                  assume and conduct the same according to its sole discretion
                  in which event Buyer shall cooperate with Seller in such
                  defense in such manner as Seller shall require.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  18. Seller's Intellectual Property
                </h2>
                <p>
                  Buyer shall not use, either directly or indirectly, in whole
                  or in part, any character, design, symbol, logo, trademark,
                  service mark, trade name, corporate name, or other mark, name,
                  title, visual or audio representation, copyright, patent or
                  other intellectual property rights that are owned or licensed
                  by Seller (collectively, "<strong className="font-semibold">Seller Materials</strong>")
                  except in the manner and to the extent that Seller may
                  specifically authorize in writing prior to any such use. An
                  Order does not convey any right, title, interest or license
                  (either explicitly, by implication or estoppel) relative to
                  the Seller Materials or the intellectual property rights of
                  any manufacturer of Products. All Seller Materials and the
                  intellectual property rights of any manufacturer of Products
                  will remain the property of Seller or the manufacturer, as
                  applicable.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  19. Confidentiality
                </h2>
                <p>
                  During the course of Buyer's dealings with Seller with respect
                  to an Order or potential Order, Buyer may gain access to
                  sensitive and/or proprietary or confidential proprietary
                  information relating to the business of Seller, its parent,
                  subsidiaries and affiliated companies, and/or their actual or
                  potential clients, customers, suppliers, distributors or
                  vendors, including, but not limited to the identity of such
                  entities and the pricing and availability of Seller's products
                  (collectively, "<strong className="font-semibold">Confidential Information</strong>").
                  Buyer agrees that neither it nor any of its representatives
                  will, at any time, directly or indirectly: (a) make use of any
                  Confidential Information except for the execution and
                  fulfillment of an Order with Seller; or (b) disclose any
                  Confidential Information to any other person or entity other
                  than as authorized by Seller in writing.{" "}
                  <strong className="font-semibold">
                    More specifically, but without limitation, Buyer agrees that
                    neither Buyer nor its representatives will, either directly
                    or indirectly, attempt to contact, contact, correspond or
                    communicate with, solicit, or enter into any contract or
                    agreement with, any client, customer, supplier, distributor
                    or vendor, or potential client, customer, supplier,
                    distributor or vendor, of Seller with respect to the
                    products that are referred to in the Order without the prior
                    written authorization of Seller.
                  </strong>{" "}
                  If Buyer has not done so already, and if requested by Seller,
                  Buyer agrees to sign Seller's standard mutual non-disclosure
                  agreement ("<strong className="font-semibold">Seller NDA</strong>") and return such
                  signed document to Seller within the time requested by Seller.
                  Buyer agree to disclose Confidential Information to its
                  employees and representatives on a need-to-know basis only.
                  The obligations of this Section shall remain in effect until
                  rescinded in writing by Seller.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  20. Assignment
                </h2>
                <p>
                  Buyer shall have no right, either voluntarily or by operation
                  of law, to assign, sublicense, subcontract, transfer or
                  otherwise dispose of all or any part of its interests,
                  obligations or rights under any Order without the prior
                  written consent of Seller. Any such attempted act by Buyer
                  without such consent shall be void and shall constitute a
                  material default and breach of any outstanding Orders. Seller
                  shall have the right, either voluntarily or by operation of
                  law, to assign, sublicense, subcontract, transfer or otherwise
                  dispose of all or any part of its interests, obligations or
                  rights under an Order (including the right to receive
                  payment), without the prior written consent of Buyer. Each
                  Order is entered into solely by and between, and may be
                  enforced only by, the Buyer and Seller (and the Seller's
                  permitted assigns) and, except to the extent expressly
                  provided for herein, is not intended to confer on any other
                  person any rights, remedies, obligations or liabilities under
                  or by reason of the Order.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  21. Governing Law
                </h2>
                <p>
                  It is agreed that the substantive and procedural laws of the
                  State of Illinois (except for its conflict of laws provisions)
                  shall apply in all respects to the interpretation and
                  enforcement of each Order. Buyer irrevocably consents to the
                  jurisdiction of the courts of the State of Illinois, with
                  venue in Cook County or, in the alternative and to the extent
                  that a basis for federal jurisdiction exists, in the United
                  States District Court for the Northern District of Illinois.
                  Buyer waives its objection to such forums, whether on the
                  basis of inconvenience, lack of personal jurisdiction or
                  otherwise. Buyer agrees that any action or lawsuit resulting
                  from any breach or alleged breach of an Order by Seller, or
                  with respect to any Products, must be commenced within one
                  year after the cause of action has accrued.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  22. Enforcement Of Order Or These Standard Terms
                </h2>
                <p>
                  In the event of any dispute between the parties concerning the
                  terms and provisions of an Order or these Standard Terms, or
                  if it becomes necessary for Seller to undertake collection
                  efforts against Buyer, then the prevailing party in any legal
                  action shall be entitled to collect from the other party all
                  third-party fees, costs and expenses incurred in such dispute,
                  including without limitation, the recovery of reasonable fees
                  and expenses of third-party attorneys, accountants and
                  experts, and all fees, costs and expenses of any appeals.
                  Buyer will be liable to Seller for all costs of collection
                  incurred by Seller (including but not limited to collection
                  agency fees and costs as well as reasonable attorneys' fees
                  and expenses), regardless of whether a lawsuit is commenced.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  23. Miscellaneous
                </h2>
                <p>
                  All representations and warranties, and all indemnification
                  and confidentiality obligations herein, shall survive the
                  expiration or termination of any Order. Nothing in any Order
                  shall be construed so as to constitute Seller and Buyer as
                  partners, joint venturers, or agent and principal, and neither
                  party shall have any authority to obligate or bind the other
                  party. No release, discharge or waiver of any provision hereof
                  shall be enforceable against or binding upon either party
                  hereto unless in writing and signed by an officer of both
                  Buyer and Seller. The failure to insist upon strict
                  performance of any of the agreements, terms, covenants or
                  conditions hereof shall not be deemed a waiver of any rights
                  or remedies that either party hereto may have or a waiver of
                  any subsequent breach or default in any of such agreements,
                  terms, covenants and conditions. Further, no waiver by either
                  party of any breach or default by the other party shall
                  constitute a waiver of any other breach or default of the same
                  or any other provision of these Standard Terms or an Order. If
                  any of the provisions of these Standard Terms or an Order
                  contravene or are invalid under the law, then it is agreed
                  that such contravention or invalidity will not invalidate the
                  whole Standard Terms or Order, but the Standard Terms or
                  Order, as applicable, will be construed as if not containing
                  the particular provisions or provisions held to be invalid,
                  and the rights and obligations of the parties will be
                  construed and enforced accordingly.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-bold text-[#202020] mb-3">
                  License Agreement (If applicable)
                </h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>
                    If, and only if, under the terms of an Order Seller will be
                    applying any character, design, symbol, logo, trademark,
                    service mark, trade name, corporate name, or other mark,
                    name, title, visual or audio representation, copyright,
                    patent or other intellectual property rights, information or
                    materials that are owned or licensed by Buyer (collectively,
                    "Buyer Materials") to the Product, then Buyer hereby grants
                    Seller a limited license to reproduce the Buyer Materials
                    specifically identified on the Order (the "Licensed
                    Material"), solely for application to the Products specified
                    in the Order. Seller shall not, without Buyer's prior
                    written consent (which consent may be withheld at Buyer's
                    sole discretion), sell, trade or otherwise dispose of
                    Products containing the Licensed Material to any third
                    party.
                  </li>
                  <li>
                    As a condition to the grant of this Limited License, Seller
                    agrees to permanently affix proprietary notices (e.g.
                    copyright, trademark, etc.) in a form supplied by Buyer to
                    each reproduction of the Licensed Material.
                  </li>
                  <li>
                    Any limited license granted to Seller herein is personal and
                    Seller may not assign, sub-license or transfer these rights
                    to anyone without Buyer's written consent, which consent may
                    be withheld in Buyer's sole discretion.
                  </li>
                  <li>
                    Except for any license granted herein, an Order does not
                    convey any right, title, or interest relative to the Buyer
                    Materials and all Buyer Materials will remain the property
                    of Buyer.
                  </li>
                </ul>
                <p className="mt-[18px]">Effective as of August 19, 2021.</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfSale;
